import React, { Component } from "react";
import MaterialTable from "material-table";
import { connect } from "react-redux";
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import { toast } from 'react-toastify';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import {
  editmassCertificate,
  getmassCertificateList,
} from '../../actions/MassCertificate';

class ListMassCertificate extends Component {

  componentDidMount() {
    this.props.getmassCertificateList();
  }
  render() {
    let {
      menuItems
    } = this.props.sidebarState;
    let {
      massCertificateListcols,
      massCertificateListrows,
      listmassCertificateLoaderStatus
    } = this.props.massCertificateState;
    return (
      <div
        style={{ marginTop: '2rem', marginBottom: "2rem" }}
        className="container"
      >
        <Paper>
          <div className="pt-1 pl-3">
            <span className="d-flex">
              <div className="mr-auto" style={{ paddingTop: "0" }}>
                <h4 style={{ marginTop: "1rem", textTransform: "uppercase" }}>Mass Certificate List</h4>
              </div>
              <div className="d-flex flex-wrap align-content-center">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.props.history.push(menuItems['mass_certificate_create'].urlpattern)}
                  className="mr-2"
                >
                  <i className="material-icons" style={{ paddingRight: "0.5rem" }}>
                    add_circle_outline
                          </i>
                  Add Mass Certificate
                      </Button>
              </div>
            </span>
          </div>
          {
            listmassCertificateLoaderStatus ?
              <div style={{ height: "20rem" }} className="d-flex justify-content-center align-items-center">
                <CircularProgress color="primary" />
              </div> :
              <MaterialTable
                columns={massCertificateListcols}
                data={massCertificateListrows}
                title=""
                editable={{
                  onRowUpdate: (newData, oldData) =>
                    new Promise((resolve, reject) => {
                      if (newData.description != '') {
                        resolve(this.props.editmassCertificate(newData, massCertificateListrows));
                      } else {
                        toast.error("Description field should not be blank", { containerId: 'toastMsg' });
                        reject();
                      }
                    }),
                }}
                options={{ actionsColumnIndex: -1 }}
              />
          }
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    massCertificateState: state.massCertificate,
    sidebarState: state.sidebarState
  };
}

const mapDispatchToProps = dispatch => {
  return {
    getmassCertificateList: () => {
      return dispatch(getmassCertificateList())
    },
    editmassCertificate: (newData, massCertificateListrows) => {
      return dispatch(editmassCertificate(newData, massCertificateListrows))
    }
    
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ListMassCertificate));